import BANK_NAME from './BANK_NAME';

export default [
    {
        BANK_NAME: BANK_NAME.POSBank,
        BANK_CODE: "7171",
        ACCOUNT_NO_MIN_DIGIT: undefined,
        ACCOUNT_NO_MAX_DIGIT: undefined,
        ACCOUNT_NO_EXACT_DIGIT: [9],
        ACCOUNT_NO_FORBIDDEN_DIGIT: [],
    },
    {
        BANK_NAME: BANK_NAME.DBS,
        BANK_CODE: "7171",
        ACCOUNT_NO_MIN_DIGIT: undefined,
        ACCOUNT_NO_MAX_DIGIT: undefined,
        ACCOUNT_NO_EXACT_DIGIT: [10],
        ACCOUNT_NO_FORBIDDEN_DIGIT: [],
    },
    {
        BANK_NAME: BANK_NAME.OCBC,
        BANK_CODE: "7339",
        ACCOUNT_NO_MIN_DIGIT: undefined,
        ACCOUNT_NO_MAX_DIGIT: undefined,
        ACCOUNT_NO_EXACT_DIGIT: [10, 12],
        ACCOUNT_NO_FORBIDDEN_DIGIT: []
    },
    {
        BANK_NAME: BANK_NAME.HSBCCORPORATE,
        BANK_CODE: "7232",
        ACCOUNT_NO_MIN_DIGIT: undefined,
        ACCOUNT_NO_MAX_DIGIT: undefined,
        ACCOUNT_NO_EXACT_DIGIT: [],
        ACCOUNT_NO_FORBIDDEN_DIGIT: []
    },
    {
        BANK_NAME: BANK_NAME.HSBCPERSONAL,
        BANK_CODE: "9548",
        ACCOUNT_NO_MIN_DIGIT: undefined,
        ACCOUNT_NO_MAX_DIGIT: undefined,
        ACCOUNT_NO_EXACT_DIGIT: [],
        ACCOUNT_NO_FORBIDDEN_DIGIT: []
    },
    {
        BANK_NAME: BANK_NAME.SBI,
        BANK_CODE: "7991",
        ACCOUNT_NO_MIN_DIGIT: undefined,
        ACCOUNT_NO_MAX_DIGIT: undefined,
        ACCOUNT_NO_EXACT_DIGIT: [],
        ACCOUNT_NO_FORBIDDEN_DIGIT: []
    },
    {
        BANK_NAME: BANK_NAME.STANDARDCHARTERED,
        BANK_CODE: "9496",
        ACCOUNT_NO_MIN_DIGIT: undefined,
        ACCOUNT_NO_MAX_DIGIT: undefined,
        ACCOUNT_NO_EXACT_DIGIT: [10],
        ACCOUNT_NO_FORBIDDEN_DIGIT: []
    },
    {
        BANK_NAME: BANK_NAME.UOB,
        ALIAS: "UOB",
        BANK_CODE: "7375",
        ACCOUNT_NO_MIN_DIGIT: undefined,
        ACCOUNT_NO_MAX_DIGIT: undefined,
        ACCOUNT_NO_EXACT_DIGIT: [10],
        ACCOUNT_NO_FORBIDDEN_DIGIT: [],
        BRANCH_LIST: [
            {
                BRANCH_CODE: "001",
                KEY_CODE: "101"
            },
            {
                BRANCH_CODE: "002",
                KEY_CODE: "102"
            },
            {
                BRANCH_CODE: "003",
                KEY_CODE: "103"
            },
            {
                BRANCH_CODE: "004",
                KEY_CODE: "104"
            },
            {
                BRANCH_CODE: "005",
                KEY_CODE: "105"
            },
            {
                BRANCH_CODE: "006",
                KEY_CODE: "106"
            },
            {
                BRANCH_CODE: "007",
                KEY_CODE: "107"
            },
            {
                BRANCH_CODE: "008",
                KEY_CODE: "108"
            },
            {
                BRANCH_CODE: "057",
                KEY_CODE: "109"
            },
            {
                BRANCH_CODE: "010",
                KEY_CODE: "110"
            },
            {
                BRANCH_CODE: "057",
                KEY_CODE: "111"
            },
            {
                BRANCH_CODE: "012",
                KEY_CODE: "112"
            },
            {
                BRANCH_CODE: "013",
                KEY_CODE: "113"
            },
            {
                BRANCH_CODE: "014",
                KEY_CODE: "114"
            },
            {
                BRANCH_CODE: "015",
                KEY_CODE: "115"
            },
            {
                BRANCH_CODE: "016",
                KEY_CODE: "116"
            },
            {
                BRANCH_CODE: "017",
                KEY_CODE: "117"
            },
            {
                BRANCH_CODE: "018",
                KEY_CODE: "118"
            },
            {
                BRANCH_CODE: "019",
                KEY_CODE: "119"
            },
            {
                BRANCH_CODE: "020",
                KEY_CODE: "120"
            },
            {
                BRANCH_CODE: "057",
                KEY_CODE: "121"
            },
            {
                BRANCH_CODE: "022",
                KEY_CODE: "122"
            },
            {
                BRANCH_CODE: "023",
                KEY_CODE: "123"
            },
            {
                BRANCH_CODE: "024",
                KEY_CODE: "124"
            },
            {
                BRANCH_CODE: "025",
                KEY_CODE: "125"
            },
            {
                BRANCH_CODE: "059",
                KEY_CODE: "126"
            },
            {
                BRANCH_CODE: "027",
                KEY_CODE: "127"
            },
            {
                BRANCH_CODE: "028",
                KEY_CODE: "128"
            },
            {
                BRANCH_CODE: "029",
                KEY_CODE: "129"
            },
            {
                BRANCH_CODE: "030",
                KEY_CODE: "130"
            },
            {
                BRANCH_CODE: "031",
                KEY_CODE: "131"
            },
            {
                BRANCH_CODE: "032",
                KEY_CODE: "132"
            },
            {
                BRANCH_CODE: "033",
                KEY_CODE: "133"
            },
            {
                BRANCH_CODE: "034",
                KEY_CODE: "134"
            },
            {
                BRANCH_CODE: "035",
                KEY_CODE: "135"
            },
            {
                BRANCH_CODE: "036",
                KEY_CODE: "136"
            },
            {
                BRANCH_CODE: "037",
                KEY_CODE: "137"
            },
            {
                BRANCH_CODE: "038",
                KEY_CODE: "138"
            },
            {
                BRANCH_CODE: "039",
                KEY_CODE: "139"
            },
            {
                BRANCH_CODE: "040",
                KEY_CODE: "140"
            },
            {
                BRANCH_CODE: "041",
                KEY_CODE: "141"
            },
            {
                BRANCH_CODE: "042",
                KEY_CODE: "142"
            },
            {
                BRANCH_CODE: "043",
                KEY_CODE: "143"
            },
            {
                BRANCH_CODE: "044",
                KEY_CODE: "144"
            },
            {
                BRANCH_CODE: "045",
                KEY_CODE: "145"
            },
            {
                BRANCH_CODE: "046",
                KEY_CODE: "146"
            },
            {
                BRANCH_CODE: "047",
                KEY_CODE: "147"
            },
            {
                BRANCH_CODE: "048",
                KEY_CODE: "148"
            },
            {
                BRANCH_CODE: "050",
                KEY_CODE: "150"
            },
            {
                BRANCH_CODE: "051",
                KEY_CODE: "151"
            },
            {
                BRANCH_CODE: "052",
                KEY_CODE: "152"
            },
            {
                BRANCH_CODE: "053",
                KEY_CODE: "153"
            },
            {
                BRANCH_CODE: "054",
                KEY_CODE: "154"
            },
            {
                BRANCH_CODE: "055",
                KEY_CODE: "155"
            },
            {
                BRANCH_CODE: "056",
                KEY_CODE: "156"
            },
            {
                BRANCH_CODE: "057",
                KEY_CODE: "157"
            },
            {
                BRANCH_CODE: "058",
                KEY_CODE: "158"
            },
            {
                BRANCH_CODE: "059",
                KEY_CODE: "159"
            },
            {
                BRANCH_CODE: "060",
                KEY_CODE: "160"
            },
            {
                BRANCH_CODE: "062",
                KEY_CODE: "162"
            },
            {
                BRANCH_CODE: "063",
                KEY_CODE: "163"
            },
            {
                BRANCH_CODE: "064",
                KEY_CODE: "164"
            },
            {
                BRANCH_CODE: "066",
                KEY_CODE: "166"
            },
            {
                BRANCH_CODE: "067",
                KEY_CODE: "167"
            },
            {
                BRANCH_CODE: "068",
                KEY_CODE: "168"
            },
            {
                BRANCH_CODE: "069",
                KEY_CODE: "169"
            },
            {
                BRANCH_CODE: "080",
                KEY_CODE: "180"
            },
            {
                BRANCH_CODE: "057",
                KEY_CODE: "201"
            },
            {
                BRANCH_CODE: "058",
                KEY_CODE: "202"
            },
            {
                BRANCH_CODE: "059",
                KEY_CODE: "203"
            },
            {
                BRANCH_CODE: "058",
                KEY_CODE: "204"
            },
            {
                BRANCH_CODE: "060",
                KEY_CODE: "206"
            },
            {
                BRANCH_CODE: "062",
                KEY_CODE: "207"
            },
            {
                BRANCH_CODE: "059",
                KEY_CODE: "208"
            },
            {
                BRANCH_CODE: "063",
                KEY_CODE: "209"
            },
            {
                BRANCH_CODE: "060",
                KEY_CODE: "210"
            },
            {
                BRANCH_CODE: "064",
                KEY_CODE: "211"
            },
            {
                BRANCH_CODE: "066",
                KEY_CODE: "212"
            },
            {
                BRANCH_CODE: "063",
                KEY_CODE: "213"
            },
            {
                BRANCH_CODE: "060",
                KEY_CODE: "215"
            },
            {
                BRANCH_CODE: "067",
                KEY_CODE: "216"
            },
            {
                BRANCH_CODE: "068",
                KEY_CODE: "217"
            },
            {
                BRANCH_CODE: "067",
                KEY_CODE: "218"
            },
            {
                BRANCH_CODE: "069",
                KEY_CODE: "219"
            },
            {
                BRANCH_CODE: "001",
                KEY_CODE: "301"
            },
            {
                BRANCH_CODE: "046",
                KEY_CODE: "302"
            },
            {
                BRANCH_CODE: "047",
                KEY_CODE: "303"
            },
            {
                BRANCH_CODE: "048",
                KEY_CODE: "304"
            },
            {
                BRANCH_CODE: "307",
                KEY_CODE: "307"
            },
            {
                BRANCH_CODE: "308",
                KEY_CODE: "308"
            },
            {
                BRANCH_CODE: "002",
                KEY_CODE: "309"
            },
            {
                BRANCH_CODE: "004",
                KEY_CODE: "310"
            },
            {
                BRANCH_CODE: "311",
                KEY_CODE: "311"
            },
            {
                BRANCH_CODE: "006",
                KEY_CODE: "312"
            },
            {
                BRANCH_CODE: "007",
                KEY_CODE: "314"
            },
            {
                BRANCH_CODE: "057",
                KEY_CODE: "318"
            },
            {
                BRANCH_CODE: "320",
                KEY_CODE: "320"
            },
            {
                BRANCH_CODE: "037",
                KEY_CODE: "321"
            },
            {
                BRANCH_CODE: "012",
                KEY_CODE: "324"
            },
            {
                BRANCH_CODE: "327",
                KEY_CODE: "327"
            },
            {
                BRANCH_CODE: "328",
                KEY_CODE: "328"
            },
            {
                BRANCH_CODE: "013",
                KEY_CODE: "330"
            },
            {
                BRANCH_CODE: "332",
                KEY_CODE: "332"
            },
            {
                BRANCH_CODE: "014",
                KEY_CODE: "335"
            },
            {
                BRANCH_CODE: "336",
                KEY_CODE: "336"
            },
            {
                BRANCH_CODE: "064",
                KEY_CODE: "337"
            },
            {
                BRANCH_CODE: "038",
                KEY_CODE: "338"
            },
            {
                BRANCH_CODE: "016",
                KEY_CODE: "339"
            },
            {
                BRANCH_CODE: "019",
                KEY_CODE: "340"
            },
            {
                BRANCH_CODE: "020",
                KEY_CODE: "341"
            },
            {
                BRANCH_CODE: "343",
                KEY_CODE: "343"
            },
            {
                BRANCH_CODE: "024",
                KEY_CODE: "344"
            },
            {
                BRANCH_CODE: "346",
                KEY_CODE: "346"
            },
            {
                BRANCH_CODE: "059",
                KEY_CODE: "347"
            },
            {
                BRANCH_CODE: "027",
                KEY_CODE: "348"
            },
            {
                BRANCH_CODE: "028",
                KEY_CODE: "349"
            },
            {
                BRANCH_CODE: "001",
                KEY_CODE: "350"
            },
            {
                BRANCH_CODE: "351",
                KEY_CODE: "351"
            },
            {
                BRANCH_CODE: "001",
                KEY_CODE: "352"
            },
            {
                BRANCH_CODE: "066",
                KEY_CODE: "353"
            },
            {
                BRANCH_CODE: "047",
                KEY_CODE: "354"
            },
            {
                BRANCH_CODE: "015",
                KEY_CODE: "355"
            },
            {
                BRANCH_CODE: "062",
                KEY_CODE: "356"
            },
            {
                BRANCH_CODE: "018",
                KEY_CODE: "357"
            },
            {
                BRANCH_CODE: "446",
                KEY_CODE: "358"
            },
            {
                BRANCH_CODE: "029",
                KEY_CODE: "359"
            },
            {
                BRANCH_CODE: "030",
                KEY_CODE: "360"
            },
            {
                BRANCH_CODE: "031",
                KEY_CODE: "361"
            },
            {
                BRANCH_CODE: "032",
                KEY_CODE: "362"
            },
            {
                BRANCH_CODE: "035",
                KEY_CODE: "363"
            },
            {
                BRANCH_CODE: "036",
                KEY_CODE: "364"
            },
            {
                BRANCH_CODE: "037",
                KEY_CODE: "365"
            },
            {
                BRANCH_CODE: "038",
                KEY_CODE: "366"
            },
            {
                BRANCH_CODE: "039",
                KEY_CODE: "367"
            },
            {
                BRANCH_CODE: "040",
                KEY_CODE: "368"
            },
            {
                BRANCH_CODE: "041",
                KEY_CODE: "369"
            },
            {
                BRANCH_CODE: "044",
                KEY_CODE: "370"
            },
            {
                BRANCH_CODE: "045",
                KEY_CODE: "371"
            },
            {
                BRANCH_CODE: "046",
                KEY_CODE: "372"
            },
            {
                BRANCH_CODE: "050",
                KEY_CODE: "373"
            },
            {
                BRANCH_CODE: "057",
                KEY_CODE: "374"
            },
            {
                BRANCH_CODE: "059",
                KEY_CODE: "375"
            },
            {
                BRANCH_CODE: "060",
                KEY_CODE: "376"
            },
            {
                BRANCH_CODE: "064",
                KEY_CODE: "377"
            },
            {
                BRANCH_CODE: "063",
                KEY_CODE: "378"
            },
            {
                BRANCH_CODE: "067",
                KEY_CODE: "379"
            },
            {
                BRANCH_CODE: "068",
                KEY_CODE: "380"
            },
            {
                BRANCH_CODE: "307",
                KEY_CODE: "381"
            },
            {
                BRANCH_CODE: "308",
                KEY_CODE: "382"
            },
            {
                BRANCH_CODE: "311",
                KEY_CODE: "383"
            },
            {
                BRANCH_CODE: "320",
                KEY_CODE: "384"
            },
            {
                BRANCH_CODE: "327",
                KEY_CODE: "385"
            },
            {
                BRANCH_CODE: "328",
                KEY_CODE: "386"
            },
            {
                BRANCH_CODE: "332",
                KEY_CODE: "387"
            },
            {
                BRANCH_CODE: "336",
                KEY_CODE: "388"
            },
            {
                BRANCH_CODE: "343",
                KEY_CODE: "389"
            },
            {
                BRANCH_CODE: "351",
                KEY_CODE: "390"
            },
            {
                BRANCH_CODE: "431",
                KEY_CODE: "391"
            },
            {
                BRANCH_CODE: "432",
                KEY_CODE: "392"
            },
            {
                BRANCH_CODE: "437",
                KEY_CODE: "393"
            },
            {
                BRANCH_CODE: "441",
                KEY_CODE: "394"
            },
            {
                BRANCH_CODE: "447",
                KEY_CODE: "395"
            },
            {
                BRANCH_CODE: "448",
                KEY_CODE: "396"
            },
            {
                BRANCH_CODE: "001",
                KEY_CODE: "397"
            },
            {
                BRANCH_CODE: "001",
                KEY_CODE: "398"
            },
            {
                BRANCH_CODE: "492",
                KEY_CODE: "399"
            },
            {
                BRANCH_CODE: "431",
                KEY_CODE: "401"
            },
            {
                BRANCH_CODE: "432",
                KEY_CODE: "402"
            },
            {
                BRANCH_CODE: "432",
                KEY_CODE: "403"
            },
            {
                BRANCH_CODE: "432",
                KEY_CODE: "404"
            },
            {
                BRANCH_CODE: "447",
                KEY_CODE: "405"
            },
            {
                BRANCH_CODE: "328",
                KEY_CODE: "406"
            },
            {
                BRANCH_CODE: "437",
                KEY_CODE: "407"
            },
            {
                BRANCH_CODE: "028",
                KEY_CODE: "408"
            },
            {
                BRANCH_CODE: "328",
                KEY_CODE: "409"
            },
            {
                BRANCH_CODE: "336",
                KEY_CODE: "410"
            },
            {
                BRANCH_CODE: "441",
                KEY_CODE: "411"
            },
            {
                BRANCH_CODE: "432",
                KEY_CODE: "412"
            },
            {
                BRANCH_CODE: "447",
                KEY_CODE: "413"
            },
            {
                BRANCH_CODE: "441",
                KEY_CODE: "414"
            },
            {
                BRANCH_CODE: "336",
                KEY_CODE: "415"
            },
            {
                BRANCH_CODE: "446",
                KEY_CODE: "416"
            },
            {
                BRANCH_CODE: "447",
                KEY_CODE: "417"
            },
            {
                BRANCH_CODE: "001",
                KEY_CODE: "419"
            },
            {
                BRANCH_CODE: "493",
                KEY_CODE: "420"
            },
            {
                BRANCH_CODE: "494",
                KEY_CODE: "421"
            },
            {
                BRANCH_CODE: "495",
                KEY_CODE: "422"
            },
            {
                BRANCH_CODE: "496",
                KEY_CODE: "423"
            },
            {
                BRANCH_CODE: "497",
                KEY_CODE: "424"
            },
            {
                BRANCH_CODE: "418",
                KEY_CODE: "425"
            },
            {
                BRANCH_CODE: "068",
                KEY_CODE: "426"
            },
            {
                BRANCH_CODE: "001",
                KEY_CODE: "427"
            },
            {
                BRANCH_CODE: "038",
                KEY_CODE: "428"
            },
            {
                BRANCH_CODE: "431",
                KEY_CODE: "431"
            },
            {
                BRANCH_CODE: "432",
                KEY_CODE: "432"
            },
            {
                BRANCH_CODE: "001",
                KEY_CODE: "433"
            },
            {
                BRANCH_CODE: "028",
                KEY_CODE: "435"
            },
            {
                BRANCH_CODE: "027",
                KEY_CODE: "436"
            },
            {
                BRANCH_CODE: "437",
                KEY_CODE: "437"
            },
            {
                BRANCH_CODE: "441",
                KEY_CODE: "441"
            },
            {
                BRANCH_CODE: "446",
                KEY_CODE: "446"
            },
            {
                BRANCH_CODE: "447",
                KEY_CODE: "447"
            },
            {
                BRANCH_CODE: "448",
                KEY_CODE: "448"
            },
            {
                BRANCH_CODE: "001",
                KEY_CODE: "450"
            },
            {
                BRANCH_CODE: "001",
                KEY_CODE: "451"
            },
            {
                BRANCH_CODE: "045",
                KEY_CODE: "455"
            },
            {
                BRANCH_CODE: "001",
                KEY_CODE: "456"
            },
            {
                BRANCH_CODE: "015",
                KEY_CODE: "457"
            },
            {
                BRANCH_CODE: "001",
                KEY_CODE: "459"
            },
            {
                BRANCH_CODE: "001",
                KEY_CODE: "460"
            },
            {
                BRANCH_CODE: "336",
                KEY_CODE: "461"
            },
            {
                BRANCH_CODE: "016",
                KEY_CODE: "462"
            },
            {
                BRANCH_CODE: "035",
                KEY_CODE: "463"
            },
            {
                BRANCH_CODE: "492",
                KEY_CODE: "492"
            },
            {
                BRANCH_CODE: "493",
                KEY_CODE: "493"
            },
            {
                BRANCH_CODE: "494",
                KEY_CODE: "494"
            },
            {
                BRANCH_CODE: "495",
                KEY_CODE: "495"
            },
            {
                BRANCH_CODE: "046",
                KEY_CODE: "501"
            },
            {
                BRANCH_CODE: "046",
                KEY_CODE: "502"
            },
            {
                BRANCH_CODE: "046",
                KEY_CODE: "503"
            },
            {
                BRANCH_CODE: "046",
                KEY_CODE: "504"
            },
            {
                BRANCH_CODE: "046",
                KEY_CODE: "505"
            },
            {
                BRANCH_CODE: "046",
                KEY_CODE: "506"
            },
            {
                BRANCH_CODE: "046",
                KEY_CODE: "507"
            },
            {
                BRANCH_CODE: "046",
                KEY_CODE: "508"
            },
            {
                BRANCH_CODE: "001",
                KEY_CODE: "611"
            },
            {
                BRANCH_CODE: "001",
                KEY_CODE: "612"
            },
            {
                BRANCH_CODE: "001",
                KEY_CODE: "613"
            },
            {
                BRANCH_CODE: "001",
                KEY_CODE: "614"
            },
            {
                BRANCH_CODE: "001",
                KEY_CODE: "615"
            },
            {
                BRANCH_CODE: "001",
                KEY_CODE: "616"
            },
            {
                BRANCH_CODE: "001",
                KEY_CODE: "617"
            },
            {
                BRANCH_CODE: "001",
                KEY_CODE: "618"
            },
            {
                BRANCH_CODE: "001",
                KEY_CODE: "619"
            },
            {
                BRANCH_CODE: "001",
                KEY_CODE: "620"
            },
            {
                BRANCH_CODE: "630",
                KEY_CODE: "631"
            },
            {
                BRANCH_CODE: "632",
                KEY_CODE: "633"
            },
            {
                BRANCH_CODE: "635",
                KEY_CODE: "636"
            },
            {
                BRANCH_CODE: "637",
                KEY_CODE: "638"
            },
            {
                BRANCH_CODE: "639",
                KEY_CODE: "640"
            },
            {
                BRANCH_CODE: "641",
                KEY_CODE: "642"
            },
            {
                BRANCH_CODE: "643",
                KEY_CODE: "643"
            },
            {
                BRANCH_CODE: "013",
                KEY_CODE: "645"
            },
            {
                BRANCH_CODE: "643",
                KEY_CODE: "650"
            },
            {
                BRANCH_CODE: "651",
                KEY_CODE: "651"
            },
            {
                BRANCH_CODE: "653",
                KEY_CODE: "655"
            },
            {
                BRANCH_CODE: "662",
                KEY_CODE: "662"
            },
            {
                BRANCH_CODE: "662",
                KEY_CODE: "663"
            },
            {
                BRANCH_CODE: "665",
                KEY_CODE: "666"
            },
            {
                BRANCH_CODE: "497",
                KEY_CODE: "668"
            },
            {
                BRANCH_CODE: "651",
                KEY_CODE: "688"
            },
            {
                BRANCH_CODE: "665",
                KEY_CODE: "765"
            },
            {
                BRANCH_CODE: "001",
                KEY_CODE: "901"
            },
            {
                BRANCH_CODE: "343",
                KEY_CODE: "902"
            },
            {
                BRANCH_CODE: "343",
                KEY_CODE: "903"
            },
            {
                BRANCH_CODE: "332",
                KEY_CODE: "904"
            },
            {
                BRANCH_CODE: "320",
                KEY_CODE: "905"
            },
            {
                BRANCH_CODE: "004",
                KEY_CODE: "906"
            },
            {
                BRANCH_CODE: "307",
                KEY_CODE: "907"
            },
            {
                BRANCH_CODE: "308",
                KEY_CODE: "908"
            },
            {
                BRANCH_CODE: "307",
                KEY_CODE: "909"
            },
            {
                BRANCH_CODE: "030",
                KEY_CODE: "910"
            },
            {
                BRANCH_CODE: "311",
                KEY_CODE: "911"
            },
            {
                BRANCH_CODE: "032",
                KEY_CODE: "912"
            },
            {
                BRANCH_CODE: "062",
                KEY_CODE: "913"
            },
            {
                BRANCH_CODE: "063",
                KEY_CODE: "914"
            },
            {
                BRANCH_CODE: "015",
                KEY_CODE: "915"
            },
            {
                BRANCH_CODE: "014",
                KEY_CODE: "916"
            },
            {
                BRANCH_CODE: "013",
                KEY_CODE: "917"
            },
            {
                BRANCH_CODE: "343",
                KEY_CODE: "918"
            },
            {
                BRANCH_CODE: "067",
                KEY_CODE: "919"
            },
            {
                BRANCH_CODE: "320",
                KEY_CODE: "920"
            },
            {
                BRANCH_CODE: "037",
                KEY_CODE: "921"
            },
            {
                BRANCH_CODE: "001",
                KEY_CODE: "922"
            },
            {
                BRANCH_CODE: "007",
                KEY_CODE: "923"
            },
            {
                BRANCH_CODE: "311",
                KEY_CODE: "924"
            },
            {
                BRANCH_CODE: "050",
                KEY_CODE: "925"
            },
            {
                BRANCH_CODE: "059",
                KEY_CODE: "926"
            },
            {
                BRANCH_CODE: "327",
                KEY_CODE: "927"
            },
            {
                BRANCH_CODE: "328",
                KEY_CODE: "928"
            },
            {
                BRANCH_CODE: "030",
                KEY_CODE: "929"
            },
            {
                BRANCH_CODE: "038",
                KEY_CODE: "930"
            },
            {
                BRANCH_CODE: "032",
                KEY_CODE: "931"
            },
            {
                BRANCH_CODE: "332",
                KEY_CODE: "932"
            },
            {
                BRANCH_CODE: "063",
                KEY_CODE: "933"
            },
            {
                BRANCH_CODE: "343",
                KEY_CODE: "934"
            },
            {
                BRANCH_CODE: "038",
                KEY_CODE: "935"
            },
            {
                BRANCH_CODE: "336",
                KEY_CODE: "936"
            },
            {
                BRANCH_CODE: "001",
                KEY_CODE: "937"
            },
            {
                BRANCH_CODE: "038",
                KEY_CODE: "938"
            },
            {
                BRANCH_CODE: "001",
                KEY_CODE: "942"
            },
            {
                BRANCH_CODE: "035",
                KEY_CODE: "945"
            },
            {
                BRANCH_CODE: "346",
                KEY_CODE: "946"
            },
            {
                BRANCH_CODE: "001",
                KEY_CODE: "951"
            },
            {
                BRANCH_CODE: "343",
                KEY_CODE: "952"
            },
            {
                BRANCH_CODE: "343",
                KEY_CODE: "953"
            },
            {
                BRANCH_CODE: "332",
                KEY_CODE: "954"
            },
            {
                BRANCH_CODE: "320",
                KEY_CODE: "955"
            },
            {
                BRANCH_CODE: "004",
                KEY_CODE: "956"
            },
            {
                BRANCH_CODE: "307",
                KEY_CODE: "957"
            },
            {
                BRANCH_CODE: "308",
                KEY_CODE: "958"
            },
            {
                BRANCH_CODE: "307",
                KEY_CODE: "959"
            },
            {
                BRANCH_CODE: "030",
                KEY_CODE: "960"
            },
            {
                BRANCH_CODE: "311",
                KEY_CODE: "961"
            },
            {
                BRANCH_CODE: "032",
                KEY_CODE: "962"
            },
            {
                BRANCH_CODE: "062",
                KEY_CODE: "963"
            },
            {
                BRANCH_CODE: "063",
                KEY_CODE: "964"
            },
            {
                BRANCH_CODE: "015",
                KEY_CODE: "965"
            },
            {
                BRANCH_CODE: "014",
                KEY_CODE: "966"
            },
            {
                BRANCH_CODE: "013",
                KEY_CODE: "967"
            },
            {
                BRANCH_CODE: "343",
                KEY_CODE: "968"
            },
            {
                BRANCH_CODE: "067",
                KEY_CODE: "969"
            },
            {
                BRANCH_CODE: "320",
                KEY_CODE: "970"
            },
            {
                BRANCH_CODE: "037",
                KEY_CODE: "971"
            },
            {
                BRANCH_CODE: "001",
                KEY_CODE: "972"
            },
            {
                BRANCH_CODE: "007",
                KEY_CODE: "973"
            },
            {
                BRANCH_CODE: "311",
                KEY_CODE: "974"
            },
            {
                BRANCH_CODE: "050",
                KEY_CODE: "975"
            },
            {
                BRANCH_CODE: "059",
                KEY_CODE: "976"
            },
            {
                BRANCH_CODE: "327",
                KEY_CODE: "977"
            },
            {
                BRANCH_CODE: "328",
                KEY_CODE: "978"
            },
            {
                BRANCH_CODE: "030",
                KEY_CODE: "979"
            },
            {
                BRANCH_CODE: "038",
                KEY_CODE: "980"
            },
            {
                BRANCH_CODE: "032",
                KEY_CODE: "981"
            },
            {
                BRANCH_CODE: "332",
                KEY_CODE: "982"
            },
            {
                BRANCH_CODE: "063",
                KEY_CODE: "983"
            },
            {
                BRANCH_CODE: "343",
                KEY_CODE: "984"
            },
            {
                BRANCH_CODE: "038",
                KEY_CODE: "985"
            },
            {
                BRANCH_CODE: "336",
                KEY_CODE: "986"
            },
            {
                BRANCH_CODE: "001",
                KEY_CODE: "987"
            },
            {
                BRANCH_CODE: "038",
                KEY_CODE: "988"
            },
            {
                BRANCH_CODE: "001",
                KEY_CODE: "989"
            },
            {
                BRANCH_CODE: "001",
                KEY_CODE: "990"
            },
            {
                BRANCH_CODE: "001",
                KEY_CODE: "992"
            },
            {
                BRANCH_CODE: "001",
                KEY_CODE: "993"
            },
            {
                BRANCH_CODE: "035",
                KEY_CODE: "995"
            },
            {
                BRANCH_CODE: "346",
                KEY_CODE: "996"
            },
            {BRANCH_CODE:"046",KEY_CODE:"301"},
{BRANCH_CODE:"446",KEY_CODE:"429"},
{BRANCH_CODE:"495",KEY_CODE:"430"},
{BRANCH_CODE:"012",KEY_CODE:"434"},
{BRANCH_CODE:"019",KEY_CODE:"438"},
{BRANCH_CODE:"001",KEY_CODE:"465"},
{BRANCH_CODE:"036",KEY_CODE:"466"},
{BRANCH_CODE:"067",KEY_CODE:"467"},
{BRANCH_CODE:"013",KEY_CODE:"658"},
{BRANCH_CODE:"001",KEY_CODE:"701"},
{BRANCH_CODE:"332",KEY_CODE:"702"},
{BRANCH_CODE:"336",KEY_CODE:"703"},
{BRANCH_CODE:"004",KEY_CODE:"704"},
{BRANCH_CODE:"432",KEY_CODE:"705"},
{BRANCH_CODE:"446",KEY_CODE:"706"},
{BRANCH_CODE:"007",KEY_CODE:"707"},
{BRANCH_CODE:"447",KEY_CODE:"708"},
{BRANCH_CODE:"448",KEY_CODE:"709"},
{BRANCH_CODE:"493",KEY_CODE:"710"},
{BRANCH_CODE:"494",KEY_CODE:"711"},
{BRANCH_CODE:"012",KEY_CODE:"712"},
{BRANCH_CODE:"013",KEY_CODE:"713"},
{BRANCH_CODE:"014",KEY_CODE:"714"},
{BRANCH_CODE:"015",KEY_CODE:"715"},
{BRANCH_CODE:"016",KEY_CODE:"716"},
{BRANCH_CODE:"495",KEY_CODE:"717"},
{BRANCH_CODE:"018",KEY_CODE:"718"},
{BRANCH_CODE:"019",KEY_CODE:"719"},
{BRANCH_CODE:"020",KEY_CODE:"720"},
{BRANCH_CODE:"630",KEY_CODE:"721"},
{BRANCH_CODE:"632",KEY_CODE:"722"},
{BRANCH_CODE:"635",KEY_CODE:"723"},
{BRANCH_CODE:"024",KEY_CODE:"724"},
{BRANCH_CODE:"637",KEY_CODE:"725"},
{BRANCH_CODE:"026",KEY_CODE:"726"},
{BRANCH_CODE:"027",KEY_CODE:"727"},
{BRANCH_CODE:"028",KEY_CODE:"728"},
{BRANCH_CODE:"639",KEY_CODE:"729"},
{BRANCH_CODE:"030",KEY_CODE:"730"},
{BRANCH_CODE:"641",KEY_CODE:"731"},
{BRANCH_CODE:"643",KEY_CODE:"732"},
{BRANCH_CODE:"651",KEY_CODE:"733"},
{BRANCH_CODE:"662",KEY_CODE:"734"},
{BRANCH_CODE:"035",KEY_CODE:"735"},
{BRANCH_CODE:"036",KEY_CODE:"736"},
{BRANCH_CODE:"037",KEY_CODE:"737"},
{BRANCH_CODE:"038",KEY_CODE:"738"},
{BRANCH_CODE:"040",KEY_CODE:"740"},
{BRANCH_CODE:"041",KEY_CODE:"741"},
{BRANCH_CODE:"044",KEY_CODE:"744"},
{BRANCH_CODE:"045",KEY_CODE:"745"},
{BRANCH_CODE:"046",KEY_CODE:"746"},
{BRANCH_CODE:"047",KEY_CODE:"747"},
{BRANCH_CODE:"050",KEY_CODE:"750"},
{BRANCH_CODE:"653",KEY_CODE:"753"},
{BRANCH_CODE:"057",KEY_CODE:"757"},
{BRANCH_CODE:"059",KEY_CODE:"759"},
{BRANCH_CODE:"063",KEY_CODE:"763"},
{BRANCH_CODE:"066",KEY_CODE:"766"},
{BRANCH_CODE:"067",KEY_CODE:"767"},
{BRANCH_CODE:"068",KEY_CODE:"768"},
{BRANCH_CODE:"001",KEY_CODE:"769"}
        ]
    },
    {
        BANK_NAME: BANK_NAME.UOB,
        ALIAS: "UOB (Virtual Account Number)",
        BANK_CODE: "7375",
        ACCOUNT_NO_MIN_DIGIT: 7,
        ACCOUNT_NO_MAX_DIGIT: 18,
        ACCOUNT_NO_EXACT_DIGIT: [],
        ACCOUNT_NO_FORBIDDEN_DIGIT: [8, 10, 15, 16],
    },
    {
        BANK_NAME: BANK_NAME.BANK_OF_CHINA,
        ALIAS: "Bank of China Limited",
        BANK_CODE: "7083",
        ACCOUNT_NO_MIN_DIGIT: undefined,
        ACCOUNT_NO_MAX_DIGIT: undefined,
        ACCOUNT_NO_EXACT_DIGIT: [11],
        ACCOUNT_NO_FORBIDDEN_DIGIT: [],
    },
]